export function createDateFromString(dateString) {
    // Sépare la chaîne en jour, mois et année
    const [day, month, year] = dateString.split('/');

    // Crée un nouvel objet Date (Note : le mois est 0-indexé en JavaScript)
    const date = new Date(year, month - 1, day);

    return date;
}

export function permuteDateFromString(dateString) {
    // Sépare la chaîne en jour, mois et année
    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
}

export function formattedText(text) {
    return text.replace(/\n/g, "<br>");
}

export function isEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }

    return true;
}
